import type { Feature } from '../../../../types';
import { DOMAINS_WEB_FEATURE_GROUP } from './group';

export const DOMAINS_WEB_FEATURES = {
  READ: {
    guid: 'd7e93a14-5c82-4f6b-a019-3b8e72f10000',
    name: 'domains:web:read',
    description: 'View web domains and their DNS records',
    action: 'read',
    product: 'account',
    parentGuid: DOMAINS_WEB_FEATURE_GROUP.guid,
  },
  CREATE: {
    guid: 'd7e93a14-5c82-4f6b-a019-3b8e72f10001',
    name: 'domains:web:create',
    description: 'Register new web domains for the organization',
    action: 'create',
    product: 'account',
    parentGuid: DOMAINS_WEB_FEATURE_GROUP.guid,
  },
  VALIDATE_STATUS: {
    guid: 'd7e93a14-5c82-4f6b-a019-3b8e72f10002',
    name: 'domains:web:validate_status',
    description: 'Check and refresh the validation status of a web domain',
    action: 'update',
    product: 'account',
    parentGuid: DOMAINS_WEB_FEATURE_GROUP.guid,
  },
  SEND_VERIFICATION_EMAIL: {
    guid: 'd7e93a14-5c82-4f6b-a019-3b8e72f10003',
    name: 'domains:web:send_verification_email',
    description: 'Send a verification email for a web domain',
    action: 'create',
    product: 'account',
    parentGuid: DOMAINS_WEB_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: 'd7e93a14-5c82-4f6b-a019-3b8e72f10004',
    name: 'domains:web:delete',
    description: 'Remove web domains from the organization',
    action: 'delete',
    product: 'account',
    parentGuid: DOMAINS_WEB_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DOMAINS_WEB_FEATURE_GROUP } from './group';
